import { FC } from "react";
import { IOverviewSectionProps } from "../../../views/local/Private/Dashboard";
import { StyledContent } from "./styled.content";

export const Content: FC<IOverviewSectionProps<HTMLDivElement>> = ({ children, forwardRef }) => (
  <StyledContent.Wrapper ref={forwardRef} data-content-wrapper>
    <StyledContent.Inner>{children}</StyledContent.Inner>
  </StyledContent.Wrapper>
);
